import React, { useEffect, useState } from "react";
import SDLPage from "../../entities/SDLPage";
import AuthService from "../../api/AuthService";
import LoaderHelper from "../../utils/Loader/LoaderHelper";
import { useAlert } from "../../context/AlertContext";
import { useLocation } from "react-router-dom";
const SDL = () => {

  const [sdl, setSdl] = useState("")
  const { showAlert } = useAlert();

  const location = useLocation();
  const {sdlCountry} = location.state||{}

  useEffect(() => {
    getSdls();
  }, [])

  const getSdls = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getSdl(sdlCountry);
 
      if (result?.success) {
        setSdl(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const deleteSdl = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteSdl(id);
      if (result?.success) {
        getSdls();
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert(error?.message, "error");
    }
  };

  const createSdl = async (min, country, datefrom, dateTo) => {

    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.CreateSdl(min, country, datefrom, dateTo);
      if (result?.success) {
        getSdls();
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
      } else {
        showAlert(result?.message, "error");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert(error?.message, "error");
    }
  };

  const handleEditSdl = async (id, min, sdlCountry, datefrom, dateTo) => {

    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.EditSdl(id, min, sdlCountry, datefrom, dateTo);
      if (result?.success) {
        getSdls();
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
      } else {
        showAlert(result?.message, "error");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert(error?.message, "error");
    }
  };

  return (
    <>
      <SDLPage sdl={sdl} deleteSdl={deleteSdl} createSdl={createSdl} handleEditSdl={handleEditSdl} sdlCountry={sdlCountry}/>
    </>
  );
};

export default SDL;
